import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { Award } from "./award.model";

@Injectable()
export class AwardService extends CrudService {
  getRootUrl(): string {
    return "awards";
  }

  save(award: Award) {
    return super.save(award);
  }

  saveMultiple(awards: Array<Award>) {
    return super.saveMultiple(awards);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/awards/shared/award.service.ts